__turbopack_context__.v({
  "bg_gray": "SectionDescription-module-scss-module__HWQSTG__bg_gray",
  "section": "SectionDescription-module-scss-module__HWQSTG__section",
  "text_area": "SectionDescription-module-scss-module__HWQSTG__text_area",
});
